import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getUserList = async (queries = '') => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: `/user/list?${queries}`,
  });

  return data?.data;
};

export default getUserList;
